export default __webpack_public_path__ + "static/media/alahad.805742bd.png";